import React from 'react';

const SectionGridLines = () => {
    return (
        <ul className="grid_lines d-none d-md-flex justify-content-between">
            <li className="grid_line"></li>
            <li className="grid_line"></li>
            <li className="grid_line"></li>
            <li className="grid_line"></li>
            <li className="grid_line"></li>
            <li className="grid_line"></li>
            <li className="grid_line"></li>
        </ul>
    );
};

export default SectionGridLines;